const IRM_DUOM_TEIKIA_NOTARAS = '2791'
const IRM_DUOM_TEIKIA_KONSULAS = '2792'
const IRM_DUOM_TEIKIA_TEISMAS = '2793'
const IRM_DUOM_TEIKIA_NOT_PAD = '2794'
const IRM_DUOM_TEIKIA_KAL_VAD = '2795'
const IRM_DUOM_TEIKIA_NOT_PAD2 = '2796'
const IR_KAC_DARBUOTOJAS = '2778'
const IR_ADMINISTRATORIUS = '2779'
const IR_REGISTRATORIUS = '2780'
const IR_issami = '2781'
const IR_issami_su_turiniu = '2782'
const IR_santrauka = '2783'
const IR_kitos = '2784'
const IR_paslauga = '2785'
const IR_archyvas = '2786'
const IR_archyvas_kitos = '2787'
const IR_RC_darbuotojas = '2788'

const SUTARTINIAI_TEIK = [
    IRM_DUOM_TEIKIA_NOTARAS, IRM_DUOM_TEIKIA_NOT_PAD, IRM_DUOM_TEIKIA_NOT_PAD2, IRM_DUOM_TEIKIA_KAL_VAD, IRM_DUOM_TEIKIA_KONSULAS, IRM_DUOM_TEIKIA_TEISMAS,
];

const NOTARINIU_GRUPE = [
    IRM_DUOM_TEIKIA_NOTARAS, IRM_DUOM_TEIKIA_NOT_PAD, IRM_DUOM_TEIKIA_NOT_PAD2, IRM_DUOM_TEIKIA_KAL_VAD, IRM_DUOM_TEIKIA_KONSULAS
];

export default {
    IR_ADMINISTRATORIUS: IR_ADMINISTRATORIUS,
    IR_REGISTRATORIUS: IR_REGISTRATORIUS,
    IR_issami: IR_issami,
    IR_issami_su_turiniu: IR_issami_su_turiniu,
    IR_santrauka: IR_santrauka,
    IR_kitos: IR_kitos,
    IR_paslauga: IR_paslauga,
    IR_archyvas: IR_archyvas,
    IR_archyvas_kitos: IR_archyvas_kitos,
    IR_RC_darbuotojas: IR_RC_darbuotojas,
    IR_KAC_DARBUOTOJAS: IR_KAC_DARBUOTOJAS,
    NOTARAS: IRM_DUOM_TEIKIA_NOTARAS,
    KONSULAS: IRM_DUOM_TEIKIA_KONSULAS,
    TEISMAS: IRM_DUOM_TEIKIA_TEISMAS,
    NOT_PAD: IRM_DUOM_TEIKIA_NOT_PAD,
    KAL_VAD: IRM_DUOM_TEIKIA_KAL_VAD,
    NOT_PAD2: IRM_DUOM_TEIKIA_NOT_PAD2,
    SUTARTINIAI: SUTARTINIAI_TEIK,
    NOTARINIU_GRUPE: NOTARINIU_GRUPE,
}
